// View modes for CodifyDB hierarchical navigation
export const VIEW_MODES = {
  MANUFACTURERS: 'Manufacturers',
  BRANDS: 'Brands',
  PRODUCTS: 'Products',
};

// Search placeholders for each view mode
export const SEARCH_PLACEHOLDERS = {
  [VIEW_MODES.MANUFACTURERS]: 'Search manufacturers...',
  [VIEW_MODES.BRANDS]: 'Search brands...',
  [VIEW_MODES.PRODUCTS]: 'Search by name, gtin',
};

// Empty state messages for each view mode
export const EMPTY_STATE_MESSAGES = {
  [VIEW_MODES.MANUFACTURERS]: 'No manufacturers found',
  [VIEW_MODES.BRANDS]: 'No brands found for this manufacturer',
  [VIEW_MODES.PRODUCTS]: 'No products found for this brand',
};

// Display name length for cards
export const DISPLAY_NAME_LENGTH = 40;
